module.exports = __webpack_public_path__ + "static/media/sonder5.4e284ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder5.jpg
// module id = 384
// module chunks = 0